
// function handleResponsiveElements() {
//   const menuDrawer = document.getElementById('menu-drawer');
//   const inlineMenu = document.querySelector('.header__inline-menu');

//   if (window.innerWidth > 1200) {
//     menuDrawer?.remove();
//   } else {
//     inlineMenu?.remove();
//   }
// }

// window.addEventListener('DOMContentLoaded', handleResponsiveElements);
// window.addEventListener('resize', handleResponsiveElements);




window.updateCart = updateCart;
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}


document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  // WCAG 4.1.2 / ARIA 4: do NOT set role="button" here. A <summary> already has the
  // correct implicit role, and role="button" marks its children as presentational —
  // which hides the focusable <a> inside from screen readers. See ADA round 2.
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    const childLinks = document.querySelectorAll(".block__mega-menu-child-li[data-menu-title]");
    const blocks = document.querySelectorAll(".block__area-wrapper--right");
    // childLinks.forEach(li => li.classList.remove("active"));
    // blocks.forEach(blocks => blocks.classList.remove("active"));
  });
  // Add this code make menu appears on hover
  document.querySelectorAll('details.mega-menu').forEach(menuDetails => {
    const summary = menuDetails.querySelector('summary');

    // Click behavior is native to <details> — no need to handle that.

    // Hover to open
    summary.addEventListener('mouseenter', () => {
      if (!menuDetails.hasAttribute('open')) {
        menuDetails.setAttribute('open', 'true');
        summary.setAttribute('aria-expanded', 'true');
      }
    });

    // Handle mouse leave on full menu (not just summary)
    menuDetails.addEventListener('mouseleave', () => {
      menuDetails.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');

      const megaMenus = document.querySelectorAll(".mega-menu__list");

      megaMenus.forEach(menu => {
        const childLinks = menu.querySelectorAll(".block__mega-menu-child-li");
        childLinks.forEach(li => li.classList.remove("active"));
        if (childLinks.length) childLinks[0].classList.add("active");
      });

      const blockWrappers = document.querySelectorAll(".block__area-wrapper--right--wrapper");

      blockWrappers.forEach(wrapper => {
        const blocks = wrapper.querySelectorAll(".block__area-wrapper--right");
        blocks.forEach(block => block.classList.remove("active"));
        if (blocks.length) blocks[0].classList.add("active");
      });

    });
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});





const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

/*
  WCAG 2.1.2 (No Keyboard Trap) and 2.4.3 (Focus Order).

  The body of this function was commented out, which broke two things at once.
  The focusin/focusout/keydown listeners that trapFocus() registers on document
  were never removed, so the tab-cycling handlers kept accumulating after every
  overlay closed; and focus was never handed back to the control that opened the
  overlay, leaving screen reader users stranded at the top of the document.

  That is what the NVDA audit saw as "the screen reader does not navigate back to
  the cart button when pressing the close button", and as Quick View losing the
  user's place in the Best Sellers grid.
*/
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  // Guarded: a section re-render can replace the trigger while the overlay is
  // open, and focusing a detached node silently sends focus to <body> instead.
  if (elementToFocus && typeof elementToFocus.focus === 'function' && elementToFocus.isConnected) {
    elementToFocus.focus();
  }
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();


}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    this._attachMeasuraListener();
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  _attachMeasuraListener() {
    const productInfo = this.closest('product-info');
    if (!productInfo) return;
    const bound = this.validateQtyRules.bind(this);
    const tryAttach = () => {
      const measuraInput = productInfo.querySelector('.measura-legacy-block input, .measura-number-group input');
      if (measuraInput && !measuraInput._moodRewardBound) {
        measuraInput._moodRewardBound = true;
        measuraInput.addEventListener('change', bound);
        measuraInput.addEventListener('input', bound);
      }
    };
    tryAttach();
    setTimeout(tryAttach, 500);
    setTimeout(tryAttach, 1500);
  }

  onInputChange(event) {
    this.validateQtyRules();
    const checkoutBtn = document.getElementById("CartDrawer-Checkout");

    if (checkoutBtn) {
      checkoutBtn.disabled = true;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = parseFloat(this.input.value);

  

    if (event.target.name === 'plus') {
      // if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
      if (parseFloat(this.input.dataset.min) > parseFloat(this.input.step)) {
        this.input.value = this.input.dataset.min;
 

      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseFloat(this.input.min);
    }
  }

  validateQtyRules() {
    const activeInput = this.closest('product-info')?.querySelector('.measura-legacy-block input') || this.input;
    const value = parseFloat(activeInput?.value || this.input.value);
    const yard_to_meter = 0.9144;


    let rewardMultiplier = value;

    document.querySelectorAll(".block_product-reward-point").forEach(pointEl => {
      let rawPoints = pointEl.getAttribute("data-point");
      if (rawPoints) {
        let numericPoints = parseFloat(rawPoints);
        if (!isNaN(numericPoints)) {
          let finalPoints = ((numericPoints * rewardMultiplier));
          pointEl.textContent = Shopify.formatMoney(finalPoints);
        }
      }
    });




    let meters = (value * yard_to_meter).toFixed(2);
    const wrapper = this.closest('.form-quantity-input');
    if (wrapper) {
      const meterBox = wrapper.querySelector('.meter-convertor');
      if (meterBox) {
        meterBox.innerText = `(${meters} Meter${value > 1 ? "s" : ""})`;
      }
    }



    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseFloat(value) <= parseFloat(this.input.min));
    }
    if (this.input.max) {
      const max = parseFloat(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
  
    }

  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    // Handle summary click
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', (event) => {
        if (event.target.closest('.tooltip-icon svg')) {
          event.stopPropagation();
          event.preventDefault();

          const wrap = event.target.closest('.tooltip-wrap');
          wrap?.classList.toggle('active');
          return;
        }
        if (event.target.classList.contains("block_mobile_drawer-link")) {
          return;
        }
        this.onSummaryClick(event);
      })
    );
    this.querySelectorAll('button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }


  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);


class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {

      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');

    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    if (!this.classList.contains("quick-add-modal")) {
      window.pauseAllMedia();
    }
   
  }

  hide() {
    console.log("hide modal");
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    if (!this.classList.contains("quick-add-modal")) {
      window.pauseAllMedia();
    }
  }

}
customElements.define('modal-dialog', ModalDialog);


class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.initSwiper();
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  initSwiper() {
    const CollectionCarousel = document.querySelector('product-recommendations .block__featured-collection-wrapper');
    const mobileColumns = parseInt(CollectionCarousel.getAttribute('data-on-mobile-columns'));
    const desktopColumns = parseInt(CollectionCarousel.getAttribute('data-on-desktop-columns'));
    if (CollectionCarousel) {
      new Swiper(CollectionCarousel, {
        spaceBetween: 0,
        loop: true,
        grabCursor: true,
        navigation: {
          nextEl: `.slider-button--next`,
          prevEl: `.slider-button--prev`,
        },
        breakpoints: {
          200: { slidesPerView: mobileColumns, spaceBetween: 6 },
          310: { slidesPerView: mobileColumns, spaceBetween: 6 },
          // 768: { slidesPerView: mobileColumns, spaceBetween: 6 },
          768: { slidesPerView: 3, spaceBetween: 6 },
          992: { slidesPerView: 3, spaceBetween: 0 },
          1199: { slidesPerView: desktopColumns, spaceBetween: 0 },
        },
      });
    }
  }


}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

// Swatch Functionality
function updateCart(cartDrawerOpen, updatePdpATC) {
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const parser = new DOMParser();
      const html = parser.parseFromString(responseText, 'text/html');
      const updatedCartDrawer = html.querySelector('#CartDrawer');
      const currentCartDrawer = document.querySelector('#CartDrawer');
      // Replace only the CartDrawer content
      if (updatedCartDrawer && currentCartDrawer) {
        currentCartDrawer.innerHTML = updatedCartDrawer.innerHTML;
      }

      // update cart icon bubble
      fetch(`${window.Shopify.routes.root}?section_id=cart-icon-bubble`)
        .then((response) => response.text())
        .then((responseText) => {
          const parser = new DOMParser();
          const html = parser.parseFromString(responseText, 'text/html');
          const updatedCartBubble = html.querySelector('#shopify-section-cart-icon-bubble');
          const currentCartBubble = document.querySelector('#cart-icon-bubble');
          if (updatedCartBubble && currentCartBubble) {
            currentCartBubble.innerHTML = updatedCartBubble.innerHTML;
          }
        });

      // Open the cart drawer after adding the item
      if (cartDrawerOpen) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.classList.add('active');
          console.log('Cart drawer opened');
        }
      }
    })
    .catch((e) => {
      console.error(e);
    });
}

// only mobile close button drawer close js 
document.addEventListener('DOMContentLoaded', function () {
  function closeMenuDrawerIfOpen() {
    const drawer = document.getElementById('Details-menu-drawer-container');
    const summary = drawer?.querySelector('summary');

    if (drawer && drawer.hasAttribute('open')) {
      drawer.classList.remove('menu-opening');
      drawer.classList.add('menu-closing');

      // Update aria-expanded
      if (summary) summary.setAttribute('aria-expanded', 'false');

      // ❗ Remove scroll lock class
      document.body.classList.remove('overflow-hidden-tablet');

      setTimeout(() => {
        drawer.removeAttribute('open');
        drawer.classList.remove('menu-closing');
      }, 300); // Match the CSS transition duration
    }
  }
  document
    .querySelectorAll('.block__mobile-menu--back-button.main, .block__mobile-menu--close-button.main')
    .forEach((btn) => {
      btn.addEventListener('click', closeMenuDrawerIfOpen);
    });
});


function equl(name) {
  var heading = document.querySelectorAll(name);
  var titleHeight = 0;
  heading.forEach((title) => {
    var matchHeight = title.clientHeight;
    if (matchHeight > titleHeight) {
      titleHeight = title.clientHeight;
    }
  });
  heading.forEach((divHeight) => {
    divHeight.style.minHeight = titleHeight + "px";
  });
}


const $sample_atc_submit_event = async function ($form_data) {
  const $sample_addtocart_result = await fetch('/cart/add.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify($form_data)
  });
  const $atc_success_result = await $sample_addtocart_result.json();
  if ($atc_success_result.items) {
    if (document.querySelector('cart-drawer') && document.querySelector('cart-drawer').classList.contains('is-empty')) document.querySelector('cart-drawer').classList.remove('is-empty');
    const quickAddModal = document.querySelector('quick-add-modal');
    if (quickAddModal) {
      document.body.addEventListener('modalClosed', () => {
        setTimeout(() => { document.querySelector('cart-drawer').renderContents($atc_success_result) });
      }, { once: true });
      quickAddModal.hide(true);
    } else {
      document.querySelector('cart-drawer').renderContents($atc_success_result);
    }
  } else {
    console.error($atc_success_result);
  }
}

async function processWoodSampleATC(dataid, buttonElement, qty) {
  if (buttonElement) {
    buttonElement.disabled = true;
  }
const props = {};

const sku = buttonElement.getAttribute('data-sku');
if (sku) props.SKU = sku;

const processing = buttonElement.getAttribute('data-processing');
if (processing) props['Processing Time'] = processing;

const remnant = buttonElement.getAttribute('data-remenant');
if (remnant) props['Remnant Length'] = remnant;

let sample_product_atc_array = [{
  id: Number(buttonElement.getAttribute("data-id")),
  quantity: qty,
  properties: props
}];



  let sample_product_atc_formData = {
    items: sample_product_atc_array,
    sections_url: window.location.pathname,
    sections: document.querySelector('cart-drawer').getSectionsToRender().map(section => section.id)
  };
  try {
    await $sample_atc_submit_event(sample_product_atc_formData);
    if (buttonElement) {
      buttonElement.disabled = false;
    }
  } catch (error) {
    console.error('Add to cart failed:', error);
    if (buttonElement) {
      buttonElement.disabled = false; // Re-enable on failure too
    }
  }
}

function initQuantityBreaks() {
  const openModal = document.querySelector('.quick-add-modal[open]');
  if (!openModal) return;

  const breaksContainer = openModal.querySelector('.quantity-breaks');
  const breakOptionBlocks = breaksContainer?.querySelectorAll('.option-block');

  breakOptionBlocks?.forEach((optionBlock) => {
    const checkboxInput = optionBlock.querySelector('input[type="checkbox"]');
    const productInfoWrapper = optionBlock.closest('product-info');
    const quantityFieldWrapper = productInfoWrapper?.querySelector('.mf-quantity-input');
    const quantityInputField = quantityFieldWrapper?.querySelector('input[name="quantity"]');

    if (checkboxInput) {
      checkboxInput.addEventListener('change', (event) => {
        const isNowChecked = event.target.checked;

        // Uncheck other options
        breakOptionBlocks.forEach((otherBlock) => {
          const otherCheckbox = otherBlock.querySelector('input[type="checkbox"]');
          if (otherCheckbox && otherCheckbox !== event.target) {
            otherCheckbox.checked = false;
            otherBlock.classList.remove('selected');
          }
        });

        if (isNowChecked) {
          optionBlock.classList.add('selected');
          const chosenQuantity = parseInt(event.target.value) || 0;
          if (quantityInputField) {
            quantityInputField.value = chosenQuantity;
          }
        } else {
          optionBlock.classList.remove('selected');
          if (quantityInputField) {
            quantityInputField.value = 1;
          }
        }
        // Set Yard To Meter Convertor 
        const yardValue = isNowChecked ? parseInt(event.target.value) || 1 : 1;
        const yard_to_meter = 0.9144;
        let meters = (yardValue * yard_to_meter).toFixed(2);
        const meterBox = productInfoWrapper?.querySelector('.meter-convertor');
        if (meterBox) {
          meterBox.innerText = `(${meters} Meter${yardValue > 1 ? "s" : ""})`;
        }
      });
    }
  });
}

function filteView() {

  document.getElementById('collection-product-per-page')?.addEventListener('change', function () {
    const selectedOption = this.options[this.selectedIndex];
    const url = selectedOption.getAttribute('data-url');
    if (url) window.location.href = url;
  });

}
filteView();

// ================ Free Mood Tags ===============






const FREE_GIFT_REMOVED_FLAG = 'mood_free_gift_removed';
const PREV_HAS_GIFT_FLAG = 'mood_prev_has_free_gift';

/* ----------------------------------------------------------------------------
   Cart mutation serialization + drawer lock — Measura line-index safety.

   Measura maps a rendered cart row back to Shopify's cart.js payload BY LINE
   INDEX (confirmed by the vendor). Our theme runs background cart mutations after
   a customer add/update — free-gift add/remove and shipping-protection removal —
   which change the cart's line set. If the customer edits a Measura measurement
   while the drawer still shows the pre-mutation line order, the edit can be
   written to the wrong line.

   Fix: run every background mutation through ONE serial queue and keep the cart
   drawer locked (no interaction) until the final mutation has re-rendered the
   drawer from the latest cart — so the rendered line order always matches cart.js
   before the customer can touch a Measura line again. A failsafe timeout
   guarantees the drawer can never stay locked if a request hangs.
---------------------------------------------------------------------------- */
let __mfCartLockCount = 0;

function mfLockCartDrawer() {
  __mfCartLockCount += 1;
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  drawer.classList.add('mf-cart-locked');
  // Reuse the existing loading overlay for the visual busy state.
  if (typeof drawer.openWithLoading === 'function') drawer.openWithLoading();
}

function mfUnlockCartDrawer(force) {
  __mfCartLockCount = force ? 0 : Math.max(0, __mfCartLockCount - 1);
  if (__mfCartLockCount > 0) return; // other mutations still in flight
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  drawer.classList.remove('mf-cart-locked');
  const overlay = drawer.querySelector('.cart-drawer-loading-overlay');
  if (overlay) overlay.remove();
}

let __mfCartQueue = Promise.resolve();
function mfEnqueueCartMutation(task) {
  const next = __mfCartQueue.then(() => task());
  __mfCartQueue = next.catch(() => {}); // keep the chain alive on error
  return next;
}

/* Serialized background reconciliation: shipping-protection removal THEN free
   gift add/remove THEN collection free gift add/remove, with the drawer locked the
   whole time. Replaces the old fire-and-forget calls in product-form.js, cart.js
   and custom.js.

   The collection gift runs through this same queue rather than on its own timer:
   it mutates the cart's line set, so running it in parallel would reintroduce
   exactly the Measura line-index race this queue exists to prevent. */
function mfReconcileCartBackground() {
  mfLockCartDrawer();
  const failsafe = setTimeout(() => mfUnlockCartDrawer(true), 8000);
  return mfEnqueueCartMutation(async () => {
    try {
      await Promise.resolve(removeShippingProtectionItems());
      await Promise.resolve(addFreeGiftProduct());
      await Promise.resolve(reconcileCollectionGift());
    } catch (e) {
      console.error('Cart background reconcile error:', e);
    } finally {
      clearTimeout(failsafe);
      mfUnlockCartDrawer();
      if (typeof moodRewars === 'function') moodRewars();
    }
  });
}
window.mfReconcileCartBackground = mfReconcileCartBackground;

function addFreeGiftProduct() {
  const giftElement = document.querySelector('.block_cart-drawer-giftproduct');
  if (!giftElement) return;

  const freegiftPriceThreshold = parseFloat(giftElement.getAttribute('data-freegiftthreshold') || '0');
  const freegiftVariantId = parseInt(giftElement.getAttribute('data-freegiftid') || '0', 10);
  if (!freegiftPriceThreshold || !freegiftVariantId) return;

  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  const getSectionsToRender = () => (cartDrawer.getSectionsToRender?.() || []).map(s => s.id);
  const sections_url = window.location.pathname;
  const sectionsToRender = getSectionsToRender();

  // ✅ DOM check: ONLY block ADD (remove still runs)
  const domHasFreeMoodItem = document.querySelectorAll('.freemood-item').length > 0;

  // Make restricted check more reliable: remove spaces, hyphens, underscores
  const restrictedPrefixesRaw = ["DL", "LT", "ET", "SUN", "BE", "GIFT CARD"];
  const normalizeSku = (sku) => (sku || '').toUpperCase().replace(/[\s_-]+/g, '');
  const restrictedPrefixes = restrictedPrefixesRaw.map(p => normalizeSku(p));

  const isRestrictedSku = (sku) => {
    const s = normalizeSku(sku);
    return !!s && restrictedPrefixes.some(prefix => s.startsWith(prefix));
  };

  // NOTE: returned so callers (mfReconcileCartBackground) can await completion.
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const totalPrice = (cart.total_price || 0) / 100;

      const items = cart.items || [];
      const freeGiftItems = items.filter(i => i?.properties?._mood_tag === "true");
      const hasFreeGift = freeGiftItems.length > 0;

      // ✅ IMPORTANT: normal product check should EXCLUDE the free gift line itself
      const nonGiftItems = items.filter(i => i?.properties?._mood_tag !== "true");

      const hasNormalProduct = nonGiftItems.some(i => i?.sku && !isRestrictedSku(i.sku));
      const eligibleForGift = totalPrice >= freegiftPriceThreshold && hasNormalProduct;


      if ((cart.item_count || 0) === 0) {
        sessionStorage.removeItem(FREE_GIFT_REMOVED_FLAG);
        sessionStorage.removeItem(PREV_HAS_GIFT_FLAG);
        return;
      }


      if (freeGiftItems.length > 1) {
        const extras = freeGiftItems.slice(1);
        const removePromises = extras.map(extra =>
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: extra.key,
              quantity: 0,
              sections: sectionsToRender,
              sections_url
            })
          }).then(r => r.json())
        );

        return Promise.all(removePromises).then(results => {
          const updatedCart = results[results.length - 1];
          cartDrawer.renderContents(updatedCart);
          if (typeof moodRewars === 'function') moodRewars();
          sessionStorage.setItem(PREV_HAS_GIFT_FLAG, '1');
        });
      }


      const prevHadGift = sessionStorage.getItem(PREV_HAS_GIFT_FLAG) === '1';
      if (prevHadGift && !hasFreeGift && eligibleForGift) {
        sessionStorage.setItem(FREE_GIFT_REMOVED_FLAG, '1');
      }

 
      sessionStorage.setItem(PREV_HAS_GIFT_FLAG, hasFreeGift ? '1' : '0');



      if (hasFreeGift && !eligibleForGift) {
        const freeGiftItem = freeGiftItems[0];

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: freeGiftItem.key,
            quantity: 0,
            sections: sectionsToRender,
            sections_url
          })
        })
          .then(res => res.json())
          .then(updatedCart => {
            cartDrawer.renderContents(updatedCart);
            if (typeof moodRewars === 'function') moodRewars();
            sessionStorage.setItem(PREV_HAS_GIFT_FLAG, '0');
          });
      }

      // ✅ ADD only if eligible + gift not already present + DOM not already showing it + user didn't manually remove
      if (
        eligibleForGift &&
        !hasFreeGift &&
        !domHasFreeMoodItem &&
        !sessionStorage.getItem(FREE_GIFT_REMOVED_FLAG)
      ) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: freegiftVariantId,
            quantity: 1,
            properties: { _mood_tag: "true" },
            sections: sectionsToRender,
            sections_url
          })
        })
          .then(res => res.json())
          .then(updatedCart => {
            cartDrawer.renderContents(updatedCart);
            if (typeof moodRewars === 'function') moodRewars();
            sessionStorage.setItem(PREV_HAS_GIFT_FLAG, '1');
          });
      }
    })
    .catch(err => console.error('Free gift logic error:', err));
}

/* ----------------------------------------------------------------------------
   Collection free gift.

   Adds a $0 gift line whenever the cart holds any product from the configured
   trigger collection, and takes it back out when the last trigger product leaves.
   Config comes from .mf-collection-gift-config, which cart-drawer.liquid renders
   only when the feature is enabled and both settings are filled in — so with the
   feature off, everything here no-ops on the first line.

   The customer cannot remove the gift: its remove control is not rendered, and if
   the line is deleted by any other route this reconcile puts it back on the next
   cart mutation. Exactly one gift line at quantity 1 is kept.

   This is deliberately client side. Shopify Functions cannot add a cart line that
   is not already there — cart transform only expands/merges/updates existing
   lines, validation can only block checkout, and discounts only discount. The
   cart.validations function that ships alongside this is a backstop for tampering,
   not the mechanism.

   Collection membership is resolved from the public Ajax products.json endpoint
   and cached for the session, because /cart.js line items carry product_id but
   neither collections nor tags. Liquid was not used for this: a for loop over
   collection.products is capped at 50 items and would silently miss triggers in a
   larger collection.
---------------------------------------------------------------------------- */
const COLLECTION_GIFT_PROPERTY = '_ma_gift';

function mfGetCollectionGiftConfig() {
  const el = document.querySelector('.mf-collection-gift-config');
  if (!el) return null;

  const variantId = parseInt(el.getAttribute('data-gift-variant-id') || '0', 10);
  const collectionHandle = (el.getAttribute('data-trigger-collection') || '').trim();
  if (!variantId || !collectionHandle) return null;

  return { variantId, collectionHandle };
}

async function mfGetTriggerProductIds(collectionHandle) {
  const cacheKey = `mood_gift_trigger_ids_${collectionHandle}`;

  try {
    const cached = sessionStorage.getItem(cacheKey);
    if (cached) return new Set(JSON.parse(cached));
  } catch (e) {
    // sessionStorage unavailable (private mode, blocked cookies) — just fetch.
  }

  const ids = [];
  const PAGE_SIZE = 250;
  const MAX_PAGES = 8; // bounds the walk at 2000 products

  for (let page = 1; page <= MAX_PAGES; page += 1) {
    const res = await fetch(
      `/collections/${encodeURIComponent(collectionHandle)}/products.json?limit=${PAGE_SIZE}&page=${page}`
    );
    if (!res.ok) break;

    const data = await res.json();
    const products = (data && data.products) || [];
    products.forEach((p) => ids.push(p.id));
    if (products.length < PAGE_SIZE) break;
  }

  try {
    sessionStorage.setItem(cacheKey, JSON.stringify(ids));
  } catch (e) {
    // Quota or private mode — the set still works for this call.
  }

  return new Set(ids);
}

// NOTE: returned so mfReconcileCartBackground can await completion.
function reconcileCollectionGift() {
  const config = mfGetCollectionGiftConfig();
  if (!config) return Promise.resolve();

  const cartDrawer = document.querySelector('cart-drawer');
  const sectionsToRender = (cartDrawer?.getSectionsToRender?.() || []).map((s) => s.id);
  const sections_url = window.location.pathname;

  // The drawer is absent on some templates; the cart mutation still has to run,
  // only the re-render is skipped.
  const render = (cart) => {
    if (cart && cartDrawer) cartDrawer.renderContents(cart);
    if (typeof moodRewars === 'function') moodRewars();
  };

  const post = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign({}, body, { sections: sectionsToRender, sections_url })),
    }).then((r) => r.json());

  return fetch('/cart.js')
    .then((res) => res.json())
    .then(async (cart) => {
      const items = cart.items || [];
      if (!items.length) return;

      const isGiftLine = (i) => i?.properties?.[COLLECTION_GIFT_PROPERTY] === 'true';
      const giftLines = items.filter(isGiftLine);

      const triggerIds = await mfGetTriggerProductIds(config.collectionHandle);
      const hasTrigger = items.some((i) => !isGiftLine(i) && triggerIds.has(i.product_id));

      // Last trigger product gone — remove every gift line.
      if (!hasTrigger) {
        if (!giftLines.length) return;

        let updated;
        for (const line of giftLines) {
          updated = await post('/cart/change.js', { id: line.key, quantity: 0 });
        }
        render(updated);
        return;
      }

      // Trigger present, no gift yet — add exactly one.
      if (!giftLines.length) {
        const updated = await post('/cart/add.js', {
          id: config.variantId,
          quantity: 1,
          properties: { [COLLECTION_GIFT_PROPERTY]: 'true' },
        });
        render(updated);
        return;
      }

      // Trigger present — collapse to a single line at quantity 1.
      let updated;
      for (const extra of giftLines.slice(1)) {
        updated = await post('/cart/change.js', { id: extra.key, quantity: 0 });
      }
      if (giftLines[0].quantity !== 1) {
        updated = await post('/cart/change.js', { id: giftLines[0].key, quantity: 1 });
      }
      if (updated) render(updated);
    })
    .catch((err) => console.error('Collection free gift error:', err));
}
window.reconcileCollectionGift = reconcileCollectionGift;



// Listen for clicks on cart-remove-button inside cart drawer
document.addEventListener('click', (e) => {
  const cartRemoveButton = e.target.closest('.cart-remove-button');
  if (!cartRemoveButton) return;

  const cartItemRow = e.target.closest('[data-la-dn-cart-item-key]');
  if (!cartItemRow) return;

  const itemKey = cartItemRow.getAttribute('data-la-dn-cart-item-key');

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const freeGiftItem = cart.items.find(item => item.properties && item.properties._mood_tag === "true");
      if (freeGiftItem && freeGiftItem.key === itemKey) {
        // Mark free gift as removed manually
        sessionStorage.setItem(FREE_GIFT_REMOVED_FLAG, 'true');
      }
    });
});

// // Use MutationObserver to watch cart drawer changes (Dawn dynamically updates items)
// const cartDrawer = document.querySelector('cart-drawer');
// if (cartDrawer) {
//   const observer = new MutationObserver(() => {
//     addFreeGiftProduct();
//   });
//   observer.observe(cartDrawer, { childList: true, subtree: true });
// }

// // Run on page load
// document.addEventListener('DOMContentLoaded', addFreeGiftProduct);















function removeShippingProtectionItems() {
  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) return Promise.resolve();

  // SAFE version → Avoid undefined errors
  const getSectionsToRenderSafe = () => {
    const sections = cartDrawer.getSectionsToRender?.();
    if (!Array.isArray(sections)) return [];
    return sections.filter(s => s && s.id).map(s => s.id);
  };
  const sections_url = window.location.pathname;

  // Identify shipping-protection rows by their STABLE Shopify line key (data-key),
  // never by index — removing one line must not shift the position another
  // mutation (or Measura) is targeting. See mfReconcileCartBackground.
  const keys = [];
  document.querySelectorAll('.cart-item').forEach((itemEl) => {
    if (itemEl.getAttribute('data-item') === 'shipping_protection') {
      const key = itemEl.getAttribute('data-key') || itemEl.getAttribute('data-la-dn-cart-item-key');
      if (key) keys.push(key);
    }
  });
  if (!keys.length) return Promise.resolve();

  // Remove sequentially by key; render once from the final response.
  return keys.reduce(
    (chain, key) => chain.then(() =>
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity: 0,
          sections: getSectionsToRenderSafe(),
          sections_url
        })
      }).then(res => res.json())
    ),
    Promise.resolve(null)
  )
    .then((updatedCart) => {
      if (updatedCart) cartDrawer.renderContents(updatedCart);
    })
    .catch(err => console.error("Shipping protection removal error:", err));
}

function moodRewars() {
  let totalReward = 0;
  document.querySelectorAll('.cart-item').forEach(function (item) {
    const reward = parseFloat(item.getAttribute('data-reward'));
    if (!isNaN(reward)) {
      totalReward += reward;
    }
  });

  const moodPointsElement = document.querySelector('.mood-points-value');
  if (moodPointsElement) {
    moodPointsElement.textContent = Shopify.formatMoney(totalReward);
  }

}
window.lowStockThreshold = function (product) {
  try {
    const tags = product?.tags || [];

    if (
      tags.includes("Department_Fashion Fabrics") ||
      tags.includes("Department_Home Fabrics")
    ) {
      return 15;
    }

    if (tags.includes("Department_Notions")) {
      return 3;
    }

    return 5;
  } catch {
    return 5;
  }
};


// ----- Low stock check -----
window.isLowStock = function (product) {
  const qty = Number(product?.selected_variant?.inventory_quantity ?? 0);

  const threshold = window.lowStockThreshold(product);
  if (product.id == 15420459417673) {
    console.log(`Product ID: ${product.id}, Quantity: ${qty}, Threshold: ${threshold}`);

  }
  return threshold > 0 && qty > 0 && qty <= threshold;

};


// ----- Classes for stock badge -----
window.statusClasses = function (product) {
  const qty = Number(product?.selected_variant?.inventory_quantity ?? 0);
  const reorderable = product?.metafields?.custom?.reorderable === 'Yes';
  return {
    temp_unavailable: qty === 0 && reorderable,
    soldout: qty === 0 && !reorderable,
    'low-stock': window.isLowStock(product)
  };
};

// ----- Text / HTML for stock badge -----
window.stockHtml = function (product) {
  const qty = Number(product?.selected_variant?.inventory_quantity ?? 0);
  const reorderable = product?.metafields?.custom?.reorderable === 'Yes';

  if (qty === 0) {
    return reorderable ? 'Temporarily Unavailable' : 'Sold Out';
  }

  if (window.isLowStock(product)) {
    return 'Only ' + qty + ' left!';
  }

  return '';
};







function getUnitValue(product) {
  let unit = '';
  const rawUnit = product?.metafields?.custom?.stocking_unit;

  if (!rawUnit) return '';

  if (Array.isArray(rawUnit)) {
    unit = rawUnit[0];
  } else if (typeof rawUnit === 'string') {
    try {
      const parsed = JSON.parse(rawUnit);
      unit = Array.isArray(parsed) ? parsed[0] : rawUnit;
    } catch {
      unit = rawUnit;
    }
  }
  return unit ? ' / ' + String(unit).replace(/["'\[\]]/g, '').toUpperCase() : '';
}


document.addEventListener('click', function (e) {
  document.querySelectorAll('.tooltip-wrap.active').forEach(el => el.classList.remove('active'));
  const icon = e.target.closest('.tooltip-icon svg');
  if (icon) {
    icon.closest('.tooltip-wrap').classList.add('active');
    e.stopPropagation();
  }
});

function clearCart() {
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  })
    .then(response => response.json())
    .then(data => {
      console.log('Cart cleared:', data);
      location.reload(); // reload page or cart drawer
            sessionStorage.removeItem(FREE_GIFT_REMOVED_FLAG);
            sessionStorage.removeItem(PREV_HAS_GIFT_FLAG);
    })
    .catch(error => console.error('Error clearing cart:', error));
}



if (!window.location.pathname.includes("/account/login")) {

  document.querySelectorAll("a[href^='#']").forEach(anchor => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();

      const targetId = this.getAttribute("href").substring(1);
      const targetEl = document.getElementById(targetId);

      if (targetEl) {
        const yOffset = -200;
        const y = targetEl.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({
          top: y,
          behavior: "smooth"
        });
      }
    });
  });

}


function setLogoutFlag() {
  localStorage.setItem("CLEAR_CART", "1");
  console.log("Logout flag set");
}

// 🔥 Runs on EVERY page load
document.addEventListener("DOMContentLoaded", function () {

  const shouldClear = localStorage.getItem("CLEAR_CART");
  if (!shouldClear) return;

  // console.log("Clearing cart after logout");

  fetch("/cart/clear.js", {
    method: "POST",
    credentials: "same-origin"
  }).finally(() => {
    localStorage.removeItem("CLEAR_CART");
    location.reload();
    // console.log("Clearing cart done");
  });


});

// document.addEventListener("DOMContentLoaded", function () {

//   document.querySelectorAll(".block_logout-button").forEach(button => {
//     button.addEventListener("click", function (e) {
//       // e.preventDefault(); // 🔴 STOP default logout

//       // const logoutUrl = this.getAttribute("href");

//       // // Step 1: save flag
//       // localStorage.setItem("CLEAR_CART", "1");
//       // console.log("Logout clicked → flag set");

//       // // Step 2: clear cart
//       // fetch("/cart/clear.js", {
//       //   method: "POST",
//       //   credentials: "same-origin"
//       // }).finally(() => {
//       //   // Step 3: continue logout
//       //   window.location.href = logoutUrl;
//       // });
//     });
//   });

// });


document.addEventListener("DOMContentLoaded", function (event) {
  if (window.location.href.indexOf("?cart") > -1) {
    document.querySelector("#cart-icon-bubble").click();
    drawerReload();
  }
  setTimeout(() => {
    if (window.location.href.indexOf("?cart") > -1) {
      window.history.pushState({}, document.title, `${document.querySelector("body").getAttribute("data-shop")}`);
    }
  }, 1000)
})



window.CartMinQtyValidator = {
  scrollToError() {
    const errorEl = document.querySelector(".min-error");
    if (errorEl) {
      setTimeout(() => {
        errorEl.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }, 50);
    }
  },

  applyCheckoutBlock() {
    const checkoutBtn = document.getElementById("CartDrawer-Checkout");
    if (!checkoutBtn) return;

    checkoutBtn.removeEventListener("click", this._clickHandler);

    if (checkoutBtn.getAttribute("type") === "button") {
      this._clickHandler = (e) => {
        e.preventDefault();
        this.scrollToError();
      };

      checkoutBtn.addEventListener("click", this._clickHandler);
    }
  },

  run() {
    this.applyCheckoutBlock();
  }
};

document.addEventListener("DOMContentLoaded", () => {
  CartMinQtyValidator.run();
});



window.addEventListener("pageshow", function (event) {
  const navType = performance.getEntriesByType("navigation")[0]?.type;
  if (event.persisted || navType === "back_forward") {

    setTimeout(() => {
      console.log("back to page");
      removeShippingProtectionItems();
      drawerReload();
    }, "1000");
  }
});

document.addEventListener('DOMContentLoaded', function () {
  try {
    if (!window.location.search.includes('items')) return;

    const params = new URLSearchParams(window.location.search);
    const parsedItems = [];

    params.forEach((value, key) => {
      // Match id or quantity
      let m = key.match(/items\[(\d+)\]\[(id|quantity)\]/);
      if (m) {
        const idx = Number(m[1]);
        const field = m[2];
        if (!parsedItems[idx]) parsedItems[idx] = {};
        parsedItems[idx][field] = Number(value);
        return;
      }

      // ✅ Match properties
      m = key.match(/items\[(\d+)\]\[properties\]\[(.+?)\]/);
      if (m) {
        const idx = Number(m[1]);
        const propKey = decodeURIComponent(m[2]);

        if (!parsedItems[idx]) parsedItems[idx] = {};
        if (!parsedItems[idx].properties) parsedItems[idx].properties = {};

        parsedItems[idx].properties[propKey] = decodeURIComponent(value);
      }
    });

    const items = parsedItems
      .filter(Boolean)
      .map(it => ({
        id: Number(it.id || 0),
        quantity: Number(it.quantity || 0),
        ...(it.properties ? { properties: it.properties } : {})
      }))
      .filter(i => i.id > 0 && i.quantity > 0);

    const cartDrawerEl =
      document.querySelector('cart-drawer') ||
      document.querySelector('[data-cart-drawer]') ||
      null;

    let sections = [];

    if (cartDrawerEl && typeof cartDrawerEl.getSectionsToRender === 'function') {
      try {
        sections = cartDrawerEl.getSectionsToRender().map(s => s.id);
      } catch (e) {
        console.warn('getSectionsToRender threw:', e);
      }
    }

    const payload = {
      items,
      sections_url: window.location.pathname,
      sections
    };

    if (typeof $sample_atc_submit_event === 'function') {
      $sample_atc_submit_event(payload);
      window.history.pushState({}, document.title, `${document.querySelector("body").getAttribute("data-shop")}`);
    } else {
      const ev = new CustomEvent('multiAtcPayloadReady', { detail: payload });
      window.dispatchEvent(ev);
      console.info('Dispatched "multiAtcPayloadReady" event with payload:', payload);
    }

  } catch (err) {
    console.error('Error in multi-ATC initializer:', err);
  }
});


function renderWishlistCounter(swat) {
  var counter_elem = document.querySelectorAll(".swym-wishlist-header-counter"); /* Targets the span added in Step 1. */
  if (counter_elem) {
    for (var i = 0; i < counter_elem.length; i++) {
      if (swat.renderWishlistCount) {
        swat.renderWishlistCount(counter_elem[i], function (count, element) {
        });
      }
    }
  }
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(renderWishlistCounter);




document.addEventListener('click', function (e) {
  const checkoutBtn = e.target.closest('[name="checkout"], .cart__checkout-button, a[href*="checkout"]');
  if (!checkoutBtn) return;

  sessionStorage.setItem('openCartAfterCheckout', 'true');
});
document.addEventListener('DOMContentLoaded', function () {
  if (sessionStorage.getItem('openCartAfterCheckout') === 'true') {
    sessionStorage.removeItem('openCartAfterCheckout');
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.open();
      setTimeout(() => {
        drawerReload();
      }, 1000);
    }
  }
});


function drawerReload(){
fetch(`${routes.cart_url}?section_id=cart-drawer`)
  .then((response) => response.text())
  .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
      selectors.forEach((selector) => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }

      });

      console.log('Cart drawer reloaded after checkout.');
  })
  .catch((e) => {
    console.error(e);
  });
}

/** Meter Convertor — globally accessible for quick views across all pages **/
const yard_to_meter = 0.9144;
function updateMeterDisplay(yardsValue, meterBox) {
  if (!meterBox) return;
  const yards = parseFloat(yardsValue) || 0;
  if (yards <= 0) {
    meterBox.innerText = '';
    return;
  }
  const meters = (yards * yard_to_meter).toFixed(2);
  meterBox.innerText = `(${meters} Meter${yards !== 1 ? 's' : ''})`;
}

function initMeterConvertor(container = document) {
  container.querySelectorAll('.meter-convertor').forEach((meterBox) => {
    const productInfo = meterBox.closest('product-info') || meterBox.closest('.product') || document.querySelector('product-info');
    if (!productInfo) return;
    // Prevent duplicate initializations on the same meter box
    if (meterBox.dataset.syncMeterActive) return;
    meterBox.dataset.syncMeterActive = "true";

    let activeInput = null;
    let lastVal = null;

    const syncMeter = () => {
      // Find the current input (Measura takes precedence). Specifically target the number input, avoiding hidden elements.
      const currentInput = productInfo.querySelector('.measura-number-group input') || productInfo.querySelector('input[name="quantity"]');
      if (!currentInput) return;

      if (currentInput.value !== lastVal) {
        lastVal = currentInput.value;
        updateMeterDisplay(currentInput.value, meterBox);
      }

      // If we've switched to a new input element (like when Measura loads), add listeners
      if (currentInput !== activeInput) {
        currentInput.addEventListener('change', syncMeter);
        currentInput.addEventListener('input', syncMeter);
        activeInput = currentInput;
      }
    };

    // Initial sync
    syncMeter();

    // Also listen for clicks on any buttons inside product info to catch updates
    productInfo.addEventListener('click', (e) => {
      if (e.target.closest('button') || e.target.closest('.measura-stepper-btn')) {
        setTimeout(syncMeter, 50);
        setTimeout(syncMeter, 300);
      }
    }, { capture: true });

    // Mutation observer for attribute changes or re-renders by Measura
    const observer = new MutationObserver(syncMeter);
    observer.observe(productInfo, { childList: true, subtree: true, attributes: true });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  // Initialize on page load initially
  initMeterConvertor();
});

// Re-initialize securely when a Quick View modal or any new product info emits the default event
document.addEventListener('product-info:loaded', (event) => {
  initMeterConvertor(event.target);
});

